type NavLinkCounterProps = {
  count?: number;
};

const NavLinkCounter = ({ count }: NavLinkCounterProps) => {
  return (
    <span className="bg-light-gray rounded-full px-1.5 py-0.5 text-[calc(var(--text-xs)-2px)] font-medium">
      {typeof count === "number" ? count : null}
    </span>
  );
};

export default NavLinkCounter;
